
define('ldsh!modules/editor/templates/editors/seo_custom_meta_item', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-choices-list-item">\n  <div class="ed-choices-list-field">\n    <input type="text" class="ed-form-control ed-form-item-full js-meta-name" data-i18n="[placeholder]editor.seo.setMetaName" placeholder="Introduce nombre" value="' +
((__t = ( name )) == null ? '' : __t) +
'">\n  </div>\n  <div class="ed-choices-list-field">\n    <input type="text" class="ed-form-control ed-form-item-full js-meta-value" data-i18n="[placeholder]editor.seo.setMetaValue" placeholder="Introduce valor" value="' +
((__t = ( value )) == null ? '' : __t) +
'">\n  </div>\n  <div class="ed-choices-list-item-actions">\n    <button class="ed-btn-icon js-remove">\n      <span class="ed-icon ed-icon-delete"></span>\n    </button>\n  </div>\n</div>';

}
return __p
};});

